import { FontWeights } from '@bingads-webui-react/fabric-control';

const color = {
  completedBorder: '#0078d4',
  completedIcon: '#0078d4',
  inProgressIcon: '#c0def6',
  incompleteBorder: '#ebebeb',
  incompleteIcon: '#edebe9',

  background: '#fff',
  stepContentBorder: '#e1dfdd',
};

const borderWidth = '2px';

const ProgressGlyphIcons = {
  Current: 'ba-RadioBtnOn',
  Completed: 'ba-CompletedSolid',
  SubStep: 'ba-RadioBullet',
  Default: 'ba-RadioBtnOff',
};

export const getStepProgressItemGlyphicon = (step) => {
  // sub steps
  if (step.path.indexOf('.') >= 0) {
    return ProgressGlyphIcons.SubStep;
  }

  if (step.isSelected || step.containsSelected) {
    return ProgressGlyphIcons.Current;
  }

  if (step.isBehind) {
    return ProgressGlyphIcons.Completed;
  }

  return ProgressGlyphIcons.Default;
};

export const progressList = {
  width: '256px',
  paddingLeft: 20 + 8, // HIG has circle icon 20px from left, 37 from top. Circle icon is 8px radius
  paddingTop: 37 + 8,
  paddingBottom: '32px',
  overflow: 'auto',
  position: 'fixed', // To fix step wizard when scroll, need to work together with wizardContentStyles

  '& ol': {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },

  // Styles for drawing the vertical line
  '& .step-progress-list-item': {
    borderLeft: `${borderWidth} solid ${color.completedBorder}`,
    '&.step-progress-list-item-ahead': { borderLeftColor: color.incompleteBorder },
  },

  // top level list items
  '& ol.step-progress-list>.step-progress-list-item': {
    paddingTop: '24px',

    '&:first-child': {
      borderLeftColor: color.background,
      paddingTop: '0px',
    },

    '&>.step-progress-list-item-glyphicon': {
      marginLeft: '-8px',
      marginRight: '8px',
      background: color.background,
      paddingTop: '5px',
      paddingBottom: '4px',
      verticalAlign: 'middle',
    },
  },

  // nested list items
  '& ol.step-progress-list-item-list>.step-progress-list-item': {
    lineHeight: '16px',
    paddingTop: '24px',
    marginLeft: `-${borderWidth}`,

    '&>.step-progress-list-item-glyphicon': {
      marginLeft: '-8px',
      marginRight: '12px',
      background: color.background,
      paddingBottom: '1px',
      verticalAlign: 'middle',
    },
  },

  '& .step-progress-list-item-title': {
    display: 'inline-block',
    verticalAlign: 'middle',
    width: 200,
  },

  '& .step-progress-list-item-selected': { fontWeight: '600' },

  // glyphicon colors
  '& .step-progress-list-item-behind .step-progress-list-item-glyphicon': {
    color: color.completedIcon,
  },
  '& .step-progress-list-item-selected .step-progress-list-item-glyphicon, & .step-progress-list-item-contains-selected>.step-progress-list-item-glyphicon': {
    color: color.inProgressIcon,
  },
  '& .step-progress-list-item-ahead .step-progress-list-item-glyphicon': {
    color: color.incompleteIcon,
  },
};

const stepContainer = {
  borderLeft: `1px solid ${color.stepContentBorder}`,
  display: 'flex',
  flex: 'auto',
  height: '100%',
  marginLeft: progressList.width,
  overflow: 'auto',

  '& .step': {
    display: 'flex',
    flex: 'auto',
    flexDirection: 'column', // to push wizard footer to bottom
    minWidth: 550,
  },
};

const stepContent = ({ palette }) => ({
  flex: 'auto',
  marginLeft: '32px',
  marginRight: '20px',
  '& .step-title': {
    fontSize: '20px',
    fontWeight: FontWeights.semibold,
    marginTop: '32px',
  },

  '& .step-description': {
    color: palette.neutralSecondary,
    marginTop: '14px',
    marginBottom: '36px',
  },
});

const footer = {
  paddingTop: '15px',
  paddingBottom: '15px',
  height: '64px',
  borderTop: '1px solid #e1dfdd',

  '& .btn': {
    marginLeft: '32px', // 1st button distance from border. HIG is inconsistent -- 16px, 32px, 34px

    '& + .btn': {
      marginLeft: '12px', // Middle button distance from previous button. HIG is inconsistent - 8px, 12px
    },

    '&.btn-exit': {
      marginLeft: '48px', // Exit button is 48px from previous button
    },
  },
};

export const getStyles = () => ({
  progressIndicator: {
    display: 'block',
    width: '100%',
  },
});

export const verticalStepWizardStyle = {
  wizardContainer: {
    display: 'flex',
    fontSize: '14px',
    lineHeight: '20px',
    fontFamily: 'Segoe UI',
    height: '100%',

    '& .step-container': stepContainer,
  },
  stepContent,
  progressList,
  footer,
};

export const getVerticalStepWizardStyles = (__, { palette = {} }) => ({
  wizardContainer: verticalStepWizardStyle.wizardContainer,
  stepContent: verticalStepWizardStyle.stepContent({ palette }),
  progressList: verticalStepWizardStyle.progressList,
  footer: verticalStepWizardStyle.footer,
});
